// src/services/payment/dodoService.ts
import { httpsCallable } from 'firebase/functions'
import { functions } from '@/lib/firebase-config'

// Open access pass checkout (monthly or annual)
export const openDodoAccessCheckout = async ({
  teacherId,
  email,
  name,
  tier,
}: {
  teacherId: string
  email: string
  name: string
  tier: 'monthly' | 'annual'
}): Promise<void> => {
  try {
    // Call Firebase function to create DoDo payment link
    const createDodoAccessLink = httpsCallable(functions, 'createDodoAccessLink')
    const result = await createDodoAccessLink({ teacherId, tier, email, name })
    const { paymentUrl } = result.data as { paymentUrl: string }

    // Redirect to DoDo checkout
    window.location.href = paymentUrl
  } catch (error: any) {
    console.error('DoDo access checkout error:', error)
    throw error
  }
}

// Open one-time payment checkout (Emergency Boost)
export const openDodoEmergencyCheckout = async ({
  teacherId,
  email,
  name,
}: {
  teacherId: string
  email: string
  name: string
}): Promise<void> => {
  try {
    // Call Firebase function to create DoDo payment link
    const createDodoEmergencyLink = httpsCallable(functions, 'createDodoEmergencyLink')
    const result = await createDodoEmergencyLink({ teacherId, email, name })
    const { paymentUrl } = result.data as { paymentUrl: string }

    // Redirect to DoDo checkout
    window.location.href = paymentUrl
  } catch (error: any) {
    console.error('DoDo emergency checkout error:', error)
    throw error
  }
}